import FinalAttestationProtocolPage from "./FinalAttestationProtocolPage";

export default FinalAttestationProtocolPage;